import { infiniteQueryOptions } from "@tanstack/react-query"
import axios from "axios"
import { ConversationTimelineResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

export type ConversationTimelinePage = z.infer<typeof ConversationTimelineResponseDataSchema>
type Response = DataResponse<ConversationTimelinePage>

type PageParam = { beforeMessageId?: string }

export const getConversationTimelineQueryKey = (conversationId: string, includeRaw = false) => [
  "conversationTimeline",
  { conversationId, includeRaw },
]

type Options = {
  limit?: number
  enabled?: boolean
  includeRaw?: boolean
}

export const conversationTimelineQuery = (conversationId: string, options: Options = {}) => {
  const limit = options.limit ?? 50
  const includeRaw = options.includeRaw ?? false

  return infiniteQueryOptions({
    queryKey: getConversationTimelineQueryKey(conversationId, includeRaw),
    // Reusing previous conversation data here shows the wrong timeline while
    // the new conversation is loading.
    placeholderData: undefined,
    initialPageParam: {} as PageParam,
    queryFn: async ({ pageParam }) => {
      const response = await axios.get<Response>(`/conversations/${conversationId}/timeline`, {
        params: {
          limit,
          beforeMessageId: pageParam.beforeMessageId,
          includeRaw,
        },
      })
      return response.data.data
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage.pageInfo.hasMore || !lastPage.pageInfo.oldestMessageId) return undefined
      return { beforeMessageId: lastPage.pageInfo.oldestMessageId }
    },
    getPreviousPageParam: () => undefined,
    enabled: options.enabled,
  })
}
